import Config from "../../../config/config";
import * as actionTypes from "../actionTypes";
import {Auth} from "aws-amplify";
import AWS from "aws-sdk";
import Messages, {INotificationError, NotificationErrTypes} from "../../../helper/messages";
import * as actions from "../index";
import {CognitoUserAttribute, CognitoUserPool,} from "amazon-cognito-identity-js";
import moment from "moment";
import UtilService from "../../../helper/service";
import roles from "../../../helper/roles";
import * as ImmersionGQL from "../../../gql";

const AmazonCognitoIdentity = require("amazon-cognito-identity-js");

// fail notification
const notificationFail = (err: any, errormessage?: string) => {
  let msg = Messages.NOTIFICATIONS.ERROR.someThingWrong
  if (errormessage) {
    msg = errormessage
  }
  if (err.graphQLErrors && err.graphQLErrors.length > 0) {
    msg = err.graphQLErrors[0].message;
  } else if (err.message) {
    msg = err.message;
  }
  return {
    type: actionTypes.ADD_NEW_NOTIFICATION_FAIL,
    state: msg
  }
}

// success notification
const notificationSuccess = (message: any) => {
  return {
    type: actionTypes.ADD_NEW_NOTIFICATION_SUCCESS,
    state: message
  }
}
// login user success
const loginUserSuccess = (user: any) => ({
  type: actionTypes.LOGIN_USER_SUCCESS,
  payload: user,
});

// register user success
const registerUserSuccess = (user: any) => ({
  type: actionTypes.REGISTER_USER_SUCCESS,
  payload: user,
});

// register user error
const registerUserError = (user: any) => ({
  type: actionTypes.REGISTER_USER_ERROR,
  payload: user,
});

// account not verify error
const accountNotVerifyError = (user: any) => ({
  type: actionTypes.ACCOUNT_NOT_VERIFY_ERROR,
  payload: user,
});

// password created
const passwordCreated = (user: any) => ({
  type: actionTypes.PASSWORD_CREATED,
  payload: user,
});

const updatePrivacyData = (data: any[]) => ({
  type: actionTypes.UPDATE_PRIVACY_SIGN,
  payload: data
});
const loginDetails = (data: any[]) => ({
  type: actionTypes.LOGIN_DETAILS,
  payload: data
});

// change password profile
const changePasswordStatus = (user: any) => ({
  type: actionTypes.CHANGE_PASSWORD_PROFILE,
  payload: user,
});

// handle user session
const handleSession = (session: any) => {
  return {
    IdToken: session ? session.getIdToken().getJwtToken() : null,
    user_id: session ? session.sub : null,
    AccessToken: session ? session.getAccessToken().getJwtToken() : null,
    RefreshToken: session ? session.getRefreshToken().getToken() : null,
    isValid: session ? session.isValid() : false,
    email: session ? session.getIdToken().payload.email : null,
    name: session ? session.getIdToken().payload.name : null,
    first_name: session ? session.given_name : null,
    middle_name: session ? session.middle_name : null,
    displayname: session
      ? session.displayname
        ? session.displayname.split("_").join(" ")
        : session.name
          ? session.name.split("_").join(" ")
          : null
      : null,
    last_name: session ? session.family_name : null,
    user_role: session ? session.role : null,
  };
};
// handle Session email
const handleSessionemail = (session: any) => {
  return {
    email: session ? session : null,
  };
};

// check auth State
const authStateChecked = (session: any) => {
  return {
    type: actionTypes.AUTH_LOGIN_STATE_CHECKED,
    payload: session,
  };
};

const passwordWrong = (client: any, email: string) => {
  client.query({
    query: ImmersionGQL.queryPasswordWrong,
    fetchPolicy: "no-cache",
    variables: {
      email: email.toLowerCase().trim()
    }
  }).then(() => {})
    .catch(() => {})
}

// get user profile success
export const getUserProfileSuccess = (userProfileData: any) => ({
  type: actionTypes.GET_USER_PROFILE,
  payload: userProfileData,
});

// logout User Success
export const logoutUserSuccess = (user?: any) => ({
  type: actionTypes.LOGOUT_USER_SUCCESS,
  payload: user,
});

// get user prefrences success
export const getUserPreferencesSuccess = (userPrefrencesData: any) => ({
  type: actionTypes.GET_USER_PREFRENCES,
  payload: userPrefrencesData,
});

export const cognitoLogin = (client: any, request: any, response: any) => {
  return (dispatch: any) => {
    const authenticationData = {
      Username: request.email.toLowerCase().trim(),
      Password: request.password,
    };
    const authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
      authenticationData
    );
    const poolData = {
      UserPoolId: Config.CONFIG.USER_POOL,
      ClientId: Config.CONFIG.CLIENT_ID,
    };
    const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
    const userData = {
      Username: request.email.toLowerCase().trim(),
      Pool: userPool,
    };
    const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: function (result: any) {
        const auth_token = result.accessToken.jwtToken
        const cognitoUser = userPool.getCurrentUser();
        if (cognitoUser != null) {
          cognitoUser.getSession(function (error: any) {
            if (error) {
              dispatch(notificationFail(error))
            } else {
              cognitoUser.getUserAttributes(function (error: any, attributes: any) {
                if (error) {
                  dispatch(notificationFail(error))
                } else {
                  for (let i = 0; i < attributes.length; i++) {
                    if (attributes[i].getName().indexOf("custom:") !== -1) {
                      const attr = attributes[i]
                        .getName()
                        .replace(/custom:/g, "");
                      result[attr] = attributes[i].getValue();
                    } else {
                      result[attributes[i].getName()] = attributes[
                        i
                      ].getValue();
                    }
                  }
                  localStorage.setItem("user_data", JSON.stringify(response))
                  localStorage.setItem("auth_token", auth_token)
                  localStorage.setItem("idToken", result.idToken ? result.idToken.jwtToken : "")

                  setTimeout(function () {
                    dispatch(notificationSuccess(Messages.NOTIFICATIONS.SUCCESS.logginSuccess))
                    dispatch(authStateChecked(handleSession(result)));
                    dispatch(loginUserSuccess(handleSession(result)));
                  }, 2000)
                  let redirectToHome = "/user/profile"
                  const overviewpage:any = localStorage.getItem("overviewRedirect")
                  if (response && response.role_access && response.role_access.length > 0) {
                    const trail_profile = response.role_access.filter((val: any) => val.access_name === "trial_profile");
                    if (trail_profile.length > 0 && trail_profile[0].access_value) {
                      redirectToHome = '/subscriber/user/profile';
                    }
                    const creator_dashboard = response.role_access.filter((val: any) => val.access_name === "creator_dashboard");
                    if (creator_dashboard.length > 0 && creator_dashboard[0].access_value) {                      
                      if(!!overviewpage) {
                        redirectToHome = overviewpage
                      } else {
                        redirectToHome = "/creator/dashboard"
                      }
                    } else if (UtilService.checkTrialAccess(response, roles['trial']['dashboard'])) {
                      if(!!overviewpage) {
                        redirectToHome = overviewpage
                      } else {
                        redirectToHome = "/subscriber/creator/dashboard";
                      }
                    } else {
                      const participant_dashboard = response.role_access.filter((val: any) => val.access_name === "participant_dashboard")
                      if (participant_dashboard.length > 0 && participant_dashboard[0].access_value) {
                        redirectToHome = "/participant/dashboard"
                      }
                    }
                    if (response.hasOwnProperty("creator_on_board") && response.creator_on_board) {
                      const creator_onboarding = response.role_access.filter((val: any) => val.access_name === "creator_onboarding");
                      const trial_onboarding = response.role_access.filter((val: any) => val.access_name === "trial_onboarding");
                      if (creator_onboarding.length > 0 && creator_onboarding[0].access_value) {
                        redirectToHome = "/creator/onboarding"
                      } else if (trial_onboarding.length > 0 && trial_onboarding[0].access_value) {
                        redirectToHome = "/subscriber/creator/onboarding"
                      }
                    }
                  }
                  localStorage.removeItem("overviewRedirect")
                  window.location.replace(redirectToHome)                  
                }
              });
            }
          });
        }
      },
      onFailure: function (error: any) {
        passwordWrong(client, request.email.toLowerCase().trim());
        dispatch(notificationFail(error, error.message))
      },
    });
  }
}

// login action
export const loginUser = (client: any, request: any, history: any) => {
  return (dispatch: any) => {
    client.query({
      query: ImmersionGQL.queryLoginCustom,
      fetchPolicy: "no-cache",
      variables: {
        email: request.email.toLowerCase().trim(),
        password: request.password,
        timezone: moment.tz.guess()
      }
    })
      .then((response: any) => {
        if (response.data.loginCustom.status === "true") {
          if (response.data.loginCustom.data.documents && response.data.loginCustom.data.documents.length) {
            dispatch(updatePrivacyData(response.data.loginCustom.data));
            dispatch(loginDetails(request));
          } else {
            dispatch(cognitoLogin(client, request, response.data.loginCustom.data))
          }
        } else {
          let message: string = Messages.NOTIFICATIONS.ERROR.userNotFound;
          const notificationError: INotificationError = Messages.NOTIFICATIONS.ERROR;
          const messagecode: NotificationErrTypes = response.data.loginCustom.messagecode;
          if (messagecode && notificationError[messagecode]) {
            message = notificationError[messagecode]
            if (messagecode === "accountNotVerified") {
              dispatch(accountNotVerifyError(response.data.loginCustom.data))
            } else if (messagecode === "passwordNotSet") {
              history.push("/user/create-password?email=" + response.data.loginCustom.data.username)
            } else if (messagecode === "accountLocked" || messagecode === "accountDeactive") {
              const windowObject: any = window;
              if (windowObject?.Intercom) {
                windowObject.Intercom("show")
              }
            }
          } else {
            if (response.data.loginCustom.message) {
              message = response.data.loginCustom.message
            }
          }
          if (messagecode && messagecode === 'passwordWrong') {
            passwordWrong(client, request.email.toLowerCase().trim());
          }
          dispatch(notificationFail({}, message))
        }
      }).catch((error: any) => {
        dispatch(notificationFail(error))
      });
  }
}


//users reset password
export const myPassReset = (client: any, request: any, history: any) => {
  return (dispatch: any) => {
    client.mutate({
      mutation: ImmersionGQL.mutationchangePassword,
      fetchPolicy: "no-cache",
      variables: {
        newpassword: request.new_password,
        oldpassword: request.old_password,
        useremail: request.email.toLowerCase().trim()
      }
    }).then((response: any) => {
      if (response.data.changePassword.status === "true") {
        dispatch(notificationSuccess(Messages.NOTIFICATIONS.SUCCESS.createPasswordSuccess))
        localStorage.setItem("auto_login","true")
        history.push("/user/login", { email: request.email.toLowerCase().trim(), password: request.new_password });
      } else {
        let message = Messages.NOTIFICATIONS.ERROR.createPasswordFail
        if (response.data.changePassword.message) {
          message = response.data.changePassword.message
        }
        dispatch(notificationFail({}, message))
      }
    }).catch(() => {
      dispatch(notificationFail({}, Messages.NOTIFICATIONS.ERROR.createPasswordFail))
    });
  }
};

//users resister
export const registerUser = (client: any, request: any, history: any) => {
  return async (dispatch: any) => {
    // check if email is already registred in system
    client.query({
      query: ImmersionGQL.queryCheckEmail,
      fetchPolicy: "no-cache",
      variables: {
        email: request.email.toLowerCase().trim(),
      }
    })
      .then((mailResponse: any) => {
        if (mailResponse.data.checkEmail.status === "true") {
          const poolData = {
            UserPoolId: Config.CONFIG.USER_POOL, // Your user pool id here
            ClientId: Config.CONFIG.CLIENT_ID, // Your client id here
          };
          client.query({
            query: ImmersionGQL.queryDefaultTenant,
            fetchPolicy: "no-cache",
            variables: {
              email: request.email.toLowerCase().trim(),
            }
          })
            .then((response: any) => {
              if (response.data && response.data.defaultTenant && response.data.defaultTenant.customer_name && response.data.defaultTenant.display_name) {
                const userPool: any = new CognitoUserPool(poolData);
                const attributeList = [];
                const dataEmail = {
                  Name: "email",
                  Value: request.email.toLowerCase().trim(),
                };
                const dataFirstName = {
                  Name: "given_name",
                  Value: request.fname,
                };
                const dataLastName = {
                  Name: "family_name",
                  Value: request.lname,
                };
                const dataMiddleName = {
                  Name: "middle_name",
                  Value: "",
                };
                const dataName = {
                  Name: "name",
                  Value: response.data.defaultTenant.display_name,
                };
                const tenantName = {
                  Name: "custom:tenantname",
                  Value: response.data.defaultTenant.customer_name,
                };

                const attributeEmail = new CognitoUserAttribute(dataEmail);
                const attributeFirstname = new CognitoUserAttribute(dataFirstName);
                const attributeLastname = new CognitoUserAttribute(dataLastName);
                const attributeMiddlename = new CognitoUserAttribute(dataMiddleName);
                const attributeName = new CognitoUserAttribute(dataName);
                const attributeTenantName = new CognitoUserAttribute(tenantName);

                attributeList.push(attributeEmail);
                attributeList.push(attributeFirstname);
                attributeList.push(attributeLastname);
                attributeList.push(attributeMiddlename);
                attributeList.push(attributeName);
                attributeList.push(attributeTenantName);

                userPool.signUp(
                  request.email.toLowerCase().trim(),
                  "TenantAccountP@ssword1!!",
                  attributeList,
                  null,
                  function (err: any) {
                    if (err) {
                      dispatch(
                        registerUserError({
                          user_id: "",
                          email: "",
                          first_name: "",
                          last_name: "",
                          displayname: "",
                        })
                      );
                      if (err.code === "UsernameExistsException") {
                        dispatch(notificationFail(err, err.message))
                      } else {
                        console.log(err.message);
                      }
                    } else {
                      // let payload = {
                      //   email: request.email,
                      //   firstname: request.fname,
                      //   lastname: request.lname,
                      //   customername: response.data.defaultTenant.customer_name,
                      //   displayname: response.data.defaultTenant.display_name
                      // };

                      let signupVariables = {};
                      let mutationObject = {};

                      if (request.prepaid) {
                        signupVariables = {
                          middlename: "",
                          display: response.data.defaultTenant.display_name,
                          customername: response.data.defaultTenant.customer_name,
                          lastname: request.lname,
                          firstname: request.fname,
                          username: request.email.toLowerCase().trim(),
                          rsc: request.rsc,
                          prepaid: true,
                          billing_subscription_id: request.billing_subscription_id,
                          billing_customer_id: request.billing_customer_id,
                          billing_price_id: request.billing_price_id,
                          billing_product_id: request.billing_product_id,
                          billing_product_name: request.billing_product_name
                          
                          
                        };

                        //mutationSignupPrepaid
                        mutationObject = {
                          mutation: ImmersionGQL.mutationSignupPrepaid,
                          fetchPolicy: "no-cache",
                          variables: signupVariables
                        };

                        //console.log(mutationObject);

                      } else {
                        signupVariables = {
                          middlename: "",
                          display: response.data.defaultTenant.display_name,
                          customername: response.data.defaultTenant.customer_name,
                          lastname: request.lname,
                          firstname: request.fname,
                          username: request.email.toLowerCase().trim(),
                          rsc: request.rsc,
                        };

                        mutationObject = {
                          mutation: ImmersionGQL.mutationSignup,
                          fetchPolicy: "no-cache",
                          variables: signupVariables
                        };


                      }


                      client.mutate(mutationObject).then((response: any) => {
                        if (response.data.signup.status === "true") {
                          dispatch(notificationSuccess(Messages.NOTIFICATIONS.SUCCESS.userCreated))
                          dispatch(registerUserSuccess(handleSessionemail(request.email.toLowerCase().trim())));
                          history.push("/user/confirm-email");
                        } else {
                          let message: string = Messages.NOTIFICATIONS.ERROR.saveUserFail
                          const notificationError: INotificationError = Messages.NOTIFICATIONS.ERROR;
                          const messagecode: NotificationErrTypes = response.data.signup.messagecode;
                          if (messagecode && notificationError[messagecode]) {
                            message = notificationError[messagecode]
                          } else {
                            if (response.data.signup.message) {
                              message = response.data.signup.message
                            }
                          }
                          dispatch(notificationFail({}, message))
                        }
                      }).catch((e: any) => {
                        console.log(e);
                        dispatch(notificationFail({}, Messages.NOTIFICATIONS.ERROR.saveUserFail))
                      });
                    }
                  }
                )
              } else {
                dispatch(notificationFail({}, Messages.NOTIFICATIONS.ERROR.defaultTenantNotFound))
              }
            })
        } else {
          let message = Messages.NOTIFICATIONS.ERROR.saveUserFail;
          const notificationError: INotificationError = Messages.NOTIFICATIONS.ERROR;
          const messagecode: NotificationErrTypes = mailResponse.data.checkEmail.messagecode;
          
          // open the intercom window if the user is already exist
          if(mailResponse.data.checkEmail.messagecode == 'userExist'){
            const windowObject: any = window;
            if (windowObject?.Intercom) {
              windowObject.Intercom("show")
            }
          }

          if (messagecode && notificationError[messagecode]) {
            message = notificationError[messagecode]
          } else {
            if (mailResponse.data.checkEmail.message) {
              message = mailResponse.data.checkEmail.message
            }
          }
          dispatch(notificationFail({}, message))
        }
      })
  };
};

// check auth state
export const onAuthCheckState = (history: any) => {
  return (dispatch: any) => {
    const poolData = {
      UserPoolId: `${Config.CONFIG.USER_POOL}`, // Your user pool id here
      ClientId: Config.CONFIG.CLIENT_ID, // Your client id here
    };
    const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
    const cognitoUser = userPool.getCurrentUser();

    if (cognitoUser != null) {
      cognitoUser.getSession(function (error: any, session: any) {
        if (error) {
          dispatch(authStateChecked(handleSession(null)));
          return;
        }
        if (cognitoUser.username.startsWith("google")) {
          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: Config.CONFIG.IDENTITY_POOL_ID, // your identity pool id here
            Logins: {
              "accounts.google.com": session.getIdToken().getJwtToken(),
            },
          });
          localStorage.setItem("auth_token", session.accessToken.jwtToken)
          localStorage.setItem("idToken", session.idToken.jwtToken)
          dispatch(
            authStateChecked(
              handleSession(Object.assign(session, session.idToken.payload))
            )
          );
          dispatch(
            loginUserSuccess(
              handleSession(Object.assign(session, session.idToken.payload))
            )
          );
        } else {
          cognitoUser.getUserAttributes(function (error: any, attributes: any) {
            if (error) {
              if (error.code === "NotAuthorizedException") {
                dispatch(onLogout());
                history.push("/user/login");
              }
            } else {
              for (let i = 0; i < attributes.length; i++) {
                if (attributes[i].getName().indexOf("custom:") !== -1) {
                  const attr = attributes[i].getName().replace(/custom:/g, "");
                  session[attr] = attributes[i].getValue();
                } else {
                  session[attributes[i].getName()] = attributes[i].getValue();
                }
              }
              localStorage.setItem("auth_token", session.accessToken.jwtToken)
              localStorage.setItem("idToken", session.idToken.jwtToken)
              dispatch(authStateChecked(handleSession(session)));
              dispatch(loginUserSuccess(handleSession(session)));
            }
          });
        }
      });
    } else {
      dispatch(authStateChecked(handleSession(null)));
    }
  };
};

const deleteAllCookies = () => {
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
};

//users logout
export const onLogout = () => {
  return (dispatch: any) => {
    const poolData = {
      UserPoolId: Config.CONFIG.USER_POOL, // Your user pool id here
      ClientId: Config.CONFIG.CLIENT_ID, // Your client id here
    };
    const userPool = new CognitoUserPool(poolData);
    const cognitoUser: any = userPool.getCurrentUser();
    if (cognitoUser != null) {
      cognitoUser.getSession(async (err: any, session: any) => {
        if (err) {
          dispatch(authStateChecked(handleSession(null)));
        }
        if (session === null) {
          dispatch(authStateChecked(handleSession(null)));
        }
        if (session !== null && session.isValid()) {          
          deleteAllCookies();
          // dispatch(logoutUserSuccess())
          localStorage.clear();
          await Auth.signOut();
          await cognitoUser.signOut();
          // let url = `${Config.CONFIG.GATEWAY_URL}/logout?response_type=code&client_id=${Config.CONFIG.CLIENT_ID}&redirect_uri=${window.location.origin}&state=STATE&scope=openid+profile+aws.cognito.signin.user.admin`
          // let win:any = window.open(url,'popup','width=300,height=300');
          // setTimeout(function () { 
          //   window.location.replace("/user/login")
          //   win.close();
          // }, 5000);
          // if(cognitoUser.username.startsWith('google') || cognitoUser.username.startsWith('apple')) {
          // }
          const url = `${Config.CONFIG.GATEWAY_URL}/logout?client_id=${Config.CONFIG.CLIENT_ID}&logout_uri=${window.location.origin}/user/login`
          window.location.replace(url)
        } else {
          dispatch(authStateChecked(handleSession(null)));
        }
      });
    } else {
      dispatch(authStateChecked(handleSession(null)));
    }
  };
};

// resend email
export const ResendLink = (client: any, request: any) => {
  return (dispatch: any) => {
    client.query({
      query: ImmersionGQL.queryResendLink,
      fetchPolicy: "no-cache",
      variables: {
        email: request.email.toLowerCase().trim(),
        brand: request.brand ? request.brand.toLowerCase().trim() : "immersion",
      }
    })
      .then((response: any) => {
        if (response.data.resendLink.status === "true") {
          dispatch(notificationSuccess(Messages.NOTIFICATIONS.SUCCESS.reSendLinkSuccess))
        } else {
          let message = Messages.NOTIFICATIONS.ERROR.reSendLinkFail
          if (response.data.resendLink.message) {
            message = response.data.resendLink.message
          }
          dispatch(notificationFail({}, message))
        }
      }).catch(() => {
        dispatch(notificationFail({}, Messages.NOTIFICATIONS.ERROR.reSendLinkFail))
      });
  }
};

// confirm user
export const confirmUser = (client: any, request: any) => {
  return (dispatch: any) => {
    client.mutate({
      mutation: ImmersionGQL.mutationConfirmUser,
      fetchPolicy: "no-cache",
      variables: {
        email: request.email.toLowerCase().trim(),
      }
    }).then((response: any) => {
      if (response.data.confirmUser.status !== "true") {
        let message = Messages.NOTIFICATIONS.ERROR.confirmUserFail
        if (response.data.confirmUser.message) {
          message = response.data.confirmUser.message
        }
        dispatch(notificationFail({}, message))
      } else {
        dispatch(notificationSuccess(""))
        if (response.data.confirmUser.data) {          
          if (response.data.confirmUser.data.password_create) {
            dispatch(passwordCreated(true))
          }
        }
      }
    }).catch(() => {
      dispatch(notificationFail({}, Messages.NOTIFICATIONS.ERROR.confirmUserFail))
    });
  }
};

// get user profile action
export const getUserProfile = (client: any, request: any, callback?: any) => {
  return (dispatch: any) => {
    client.query({
      query: ImmersionGQL.queryGetProfile,
      fetchPolicy: "no-cache",
      variables: {
        user_id: request.user_id,
      }
    })
      .then((response: any) => {
        if (response.data) {
          dispatch(getUserProfileSuccess(response.data.getProfile));
        } else {
          dispatch(notificationFail({}, "No user found"))
        }
        callback && callback(true);
      }).catch((error: any) => {
        dispatch(notificationFail(error));
        callback && callback(true)
      });
  }
}

// get user profile action
export const getUserPreferences = (client: any, request: any) => {
  return (dispatch: any) => {
    client.query({
      query: ImmersionGQL.queryGetUserPreferences,
      fetchPolicy: "no-cache",
      variables: {
        user_id: request.user_id,
      }
    })
      .then((response: any) => {
        if (response.data) {
          if (response.data.getUserPreferences) {
            dispatch(getUserPreferencesSuccess(response.data.getUserPreferences));
          } else {
            dispatch(notificationFail({}, "No any preferences found for this user."))
          }

        } else {
          dispatch(notificationFail({}, "Sorry, this user is not found in system"))
        }
      }).catch((error: any) => {
        dispatch(notificationFail(error))
      });
  }
}

//update user profile
export const updateUserProfile = (client: any, request: any) => {
  return (dispatch: any) => {
    client.mutate({
      mutation: ImmersionGQL.mutationEditProfile,
      fetchPolicy: "no-cache",
      variables: {
        user_id: request.user_id,
        firstname: request.firstname,
        middlename: request.middlename,
        lastname: request.lastname,
        mobilenumber: request.mobile_number?request.mobile_number:"",
        cognito_username: request.cognito_username,
        mfa_enable: request.mfa_enable
      }
    }).then((response: any) => {
      if (response.data.editProfile.status === "true") {
        dispatch(notificationSuccess("Profile is updated successfully"))
        dispatch(getUserProfile(client, request))
      } else {
        dispatch(notificationFail({}, "Problem occured while update profile"))
      }
    }).catch(() => {
      dispatch(notificationFail({}, "Problem occured while update profile"))
    });
  }
};

export const createUserPreference = (client: any, request: any) => {
  return (dispatch: any) => {
    client.mutate({
      mutation: ImmersionGQL.mutationUpdatePreference,
      fetchPolicy: "no-cache",
      variables: {
        preference_information: request.preference_information,
        preference_value: Boolean(request.preference_value),
        preference_type: request.preference_type,
        preference_name: request.preference_name,
        user_id: request.user_id
      }
    }).then((response: any) => {
      if (response.data.updatePreference.status === "true") {
        dispatch(actions.getUserPreferences(client, { user_id: request.user_id }));
        dispatch(notificationSuccess("Preferences has been created successfully"));
      } else {
        dispatch(notificationFail({}, "Problem occurred while creating preference"));
      }
    }).catch(() => {
      dispatch(notificationFail({}, "Problem occurred while creating preference"));
    });
  }
};

export const updateUserPreference = (client: any, request: any) => {
  return (dispatch: any) => {
    client.mutate({
      mutation: ImmersionGQL.mutationUpdatePreference,
      fetchPolicy: "no-cache",
      variables: {
        preference_id: request.preference_id,
        preference_value: Boolean(request.preference_value),
        preference_information: request.preference_information
      }
    }).then((response: any) => {
      if (response.data.updatePreference.status === "true") {
        dispatch(actions.getUserPreferences(client, { user_id: request.user_id }));
        dispatch(notificationSuccess("Preferences has been updated successfully"));
      } else {
        dispatch(notificationFail({}, "Problem occurred while updating preference"));
      }
    }).catch(() => {
      dispatch(notificationFail({}, "Problem occurred while updating preference"));
    });
  }
};

// reset password from user profile
export const changePasswordFromProfile = (client: any, request: any) => {
  return (dispatch: any) => {
    client.mutate({
      mutation: ImmersionGQL.mutationChangeUserPassword,
      fetchPolicy: "no-cache",
      variables: {
        newpassword: request.new_password,
        oldpassword: request.old_password,
        useremail: request.email.toLowerCase().trim()
      }
    }).then((response: any) => {
      if (response.data.changeUserPassword.status === "true") {
        dispatch(changePasswordStatus({ status: true, message: Messages.NOTIFICATIONS.SUCCESS.createPasswordSuccess }))
      } else {
        let message = Messages.NOTIFICATIONS.ERROR.createPasswordFail
        if (response.data.changeUserPassword.message) {
          message = response.data.changeUserPassword.message
        }
        dispatch(changePasswordStatus({ status: false, message: message }))
      }
    }).catch((err:any) => {
      let message = Messages.NOTIFICATIONS.ERROR.createPasswordFail
      if(err.message){
        message = err.message
      }
      dispatch(changePasswordStatus({ status: false, message: message }))
    });
  }
};


// change mfa settings
export const updateMfaSetting = (client: any, request: any) => {
  return (dispatch: any) => {
    client.mutate({
      mutation: ImmersionGQL.mutationUpdateMfa,
      fetchPolicy: "no-cache",
      variables: {
        user_id: request.user_id,
        mfa: request.mfa
      }
    }).then((response: any) => {
      if (response.data.udpateMfa.status === "true") {
        dispatch(notificationSuccess(Messages.NOTIFICATIONS.SUCCESS.mfaUpdatedSuccess))
        dispatch(getUserProfile(client, request))
      } else {
        let message = Messages.NOTIFICATIONS.ERROR.mfaUpdatedFail
        if (response.data.udpateMfa.message) {
          if (response.data.udpateMfa.message === "InvalidParameterException") {
            message = Messages.NOTIFICATIONS.ERROR.invalidParameterException
          } else {
            message = response.data.udpateMfa.message
          }
        }
        dispatch(notificationFail({}, message))
      }
    }).catch(() => {
      dispatch(notificationFail({}, Messages.NOTIFICATIONS.ERROR.mfaUpdatedFail))
    });
  }
};

// reset password link send in email

export const forgotPasswordRequest = (client: any, request: any) => {
  return async (dispatch: any) => {
    client.query({
      query: ImmersionGQL.queryCheckEmail,
      fetchPolicy: "no-cache",
      variables: {
        email: request.email.toLowerCase().trim(),
      }
    })
      .then((mailResponse: any) => {
        if (mailResponse.data.checkEmail.messagecode === "userExist") {
          if (mailResponse.data.checkEmail.data.auth_type === 0) {
            if (!mailResponse.data.checkEmail.data.password_create) {
              // let template_type = "new_user_validation"
              // let link = window.location.origin + "/user/reset-password?email=" + request.email + "&expiredin=" + expiredin;
              const template_type = "new_user_validation"
              const expiredin = moment().utc().valueOf() + (1000 * 60 * 60)              
              const link = `${window.location.origin}/user/create-password?email=${request.email.toLowerCase().trim()}&expiredin=${expiredin}`
              const objectData = {
                email: request.email.toLowerCase().trim(),
                creatot_fname: mailResponse.data.checkEmail.data && mailResponse.data.checkEmail.data.first_name ? mailResponse.data.checkEmail.data.first_name : "",
                creatot_lname: mailResponse.data.checkEmail.data && mailResponse.data.checkEmail.data.last_name ? mailResponse.data.checkEmail.data.last_name : "",
                VerificationButton: link,
                validation_link: `<a href=${link}>Create password</a>`,
              }
              client.query({
                query: ImmersionGQL.querySendEmailTemplate,
                fetchPolicy: "no-cache",
                variables: {
                  template_type: template_type,
                  objectData: objectData
                }
              }).then((response: any) => {
                if (response.data.sendEmailTemplate.status === "true") {
                  dispatch(notificationSuccess(Messages.NOTIFICATIONS.SUCCESS.forgotPasswordLinkSuccess))
                } else {
                  let message = Messages.NOTIFICATIONS.ERROR.sendEmailFail
                  if (response.data.sendEmailTemplate.message) {
                    message = response.data.sendEmailTemplate.message
                  }
                  dispatch(notificationFail({}, message))
                }
              })
            } else {
              const poolData = {
                UserPoolId: Config.CONFIG.USER_POOL, // Your user pool id here
                ClientId: Config.CONFIG.CLIENT_ID, // Your client id here
              };
              const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
              const userData = {
                Username: request.email.toLowerCase().trim(),
                Pool: userPool,
              };
              const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
              cognitoUser.forgotPassword({
                onSuccess: function () {
                  dispatch(notificationSuccess(Messages.NOTIFICATIONS.SUCCESS.forgotPasswordLinkSuccess))
                },
                onFailure: function (error: any) {
                  let message = Messages.NOTIFICATIONS.ERROR.sendEmailFail
                  if(error.message){
                    message = error.message
                  }
                  dispatch(notificationFail({}, message))
                },
              });
            }            
          } else {
            const message = Messages.NOTIFICATIONS.ERROR.nonSSOToForgotPassword
            dispatch(notificationFail({}, message))
          }
        } else {
          const message = Messages.NOTIFICATIONS.ERROR.forgotPasswordEmailNotFound
          dispatch(notificationFail({}, message))
        }
      })
  };
};

// unlock user
export const unlockUser = (client: any, request: any, history: any) => {
  return (dispatch: any) => {
    client.mutate({
      mutation: ImmersionGQL.mutationUnlockUser,
      fetchPolicy: "no-cache",
      variables: {
        email: request.email
      }
    }).then((response: any) => {
      if (response.data.unlockUser.status === "true") {
        localStorage.setItem("auto_login", "true")
        history.push("/user/login", { email: request.email.toLowerCase().trim(), password: request.password });
      } else {
        let message = 'Problem while unlock user.';
        if (response.data.unlockUser.message) {
          message = response.data.unlockUser.message
        }
        dispatch(notificationFail({}, message))
      }
    }).catch((error: any) => {
      dispatch(notificationFail(error))
    });
  }
};

//set new password
export const resetPassword = (client: any, request: any, history: any) => {
  return (dispatch: any) => {
    const poolData = {
      UserPoolId: Config.CONFIG.USER_POOL, // Your user pool id here
      ClientId: Config.CONFIG.CLIENT_ID, // Your client id here
    };

    const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
    const userData = {
      Username: request.email.toLowerCase().trim(),
      Pool: userPool,
    };

    const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
    cognitoUser.confirmPassword(request.code, request.password, {
      onSuccess() {
        dispatch(unlockUser(client, request, history))
      },
      onFailure(error: any) {
        let message = Messages.NOTIFICATIONS.ERROR.createPasswordFail
        if (error.message) {
          message = error.message
        }
        dispatch(notificationFail({}, message))
      },
    });
  }
};

export const setScreenLoading = (loading: boolean) => {
  return (dispatch: any) => {
    dispatch({
      type: actionTypes.SCREEN_LOADING,
      payload: loading
    })
  }
}

export const failStoreNotification = (message: string) => {
  return (dispatch: any) => {
    dispatch({
      type: actionTypes.ADD_NEW_NOTIFICATION_FAIL,
      state: message
    })
  };
};

export const successStoreNotification = (message: string) => {
  return (dispatch: any) => {
    dispatch({
      type: actionTypes.ADD_NEW_NOTIFICATION_SUCCESS,
      state: message
    })
  }
};

// update User Profile Picture
export const updateUserProfilePicture = (client: any, request: any, callback?: any) => {
  return (dispatch: any) => {
    client.mutate({
      mutation: ImmersionGQL.mutationUploadProfilePicture,
      fetchPolicy: "no-cache",
      variables: {
        userid: request.userid,
        fileInput: request.image ? request.image[0] : "",
      }
    }).then((response: any) => {
      if (response.data.uploadProfilePicture.status === "true") {
        if (callback) {
          dispatch(getUserProfile(client, { user_id: request.userid }, (res: any) => {
            callback(res);
          }))
        } else {
          dispatch(getUserProfile(client, { user_id: request.userid }))
        }
        dispatch(notificationSuccess("Image uploaded"))
      } else {
        let message = Messages.NOTIFICATIONS.ERROR.uploadProfilePictureFail
        if (response.data.uploadProfilePicture.message) {
          message = response.data.uploadProfilePicture.message
        }
        dispatch(notificationFail({}, message));
        callback && callback(null);
      }
    }).catch((error: any) => {
      dispatch(notificationFail(error));
      callback && callback(null);
    });
  }
};

// accept document
export const acceptDocument = (client: any, request: any) => {
  return () => {
    client.mutate({
      mutation: ImmersionGQL.mutationAcceptDocument,
      fetchPolicy: "no-cache",
      variables: {
        user_id: parseInt(request.user_id),
        document_name: request.config_name,
        revision: (request.revision).toString(),
        schemaname: request.schemaname
      }
    }).then(() => {

    }).catch(() => {
    });
  }
};

// account verification
export const accountVerification = (client: any, request: any, result:any) => {
  return () => {
    client.query({
      query: ImmersionGQL.queryCheckEmail,
      fetchPolicy: "no-cache",
      variables: {
        email: request.email.toLowerCase().trim(),
      }
    })
    .then((mailResponse: any) => {
      if (mailResponse.data.checkEmail.messagecode === "userExist") {
        if(mailResponse.data.checkEmail.data && !mailResponse.data.checkEmail.data.auto_confirm) {
          client.query({
            query: ImmersionGQL.queryAccountVerification,
            fetchPolicy: "no-cache",
            variables: {
              email: request.email.toLowerCase().trim()
            }
          }).then((response: any) => {
            result(response.data.account_verification)
          }).catch(() => {
            result({status:"false",message:"",messagecode:""})
          });
        } else {
          result({status:"false",message:"",messagecode:"alreadyConfirmed"})
        }
      } else {
        result({status:"false",message:"User does not exist in system.",messagecode:""})
      }
    }).catch(() => {
      result({status:"false",message:"",messagecode:""})
    })
  }
};

// update user metrics
export const updateUserMetricsValue = (client: any, request: any) => {
  return () => {
    client.mutate({
      mutation: ImmersionGQL.mutationUpdateUserMetrics,
      fetchPolicy: "no-cache",
      variables: {
        metrics_type: request.metrics_type,
        user_id: request.user_id,
        metrics_value: request.metrics_value ? request.metrics_value : null,
      }
    }).then(() => {

    }).catch(() => {

    });
  }
};

const setVerification = (value: any) => ({
	type: actionTypes.SET_USER_VERIFICATION,
	payload: value
});

export const setIsUserVerication = (req: any) => {
	return (dispatch: any) => {
		dispatch(setVerification(req));
	}
};

export const gotGoogleUserProfile = (pictureURL: string) => ({
  type: actionTypes.GET_GOOGLE_ACCOUNT_PICTURE,
  payload: pictureURL
});

export const successGetGavatarImage = (url: string) => ({
  type: actionTypes.GET_GAVATAR_IMAGE_SUCCESS,
  payload: url
});

export const getGravatarImage = (client: any, request: any) => {
  return (dispatch: any) => {
    client.query({
      query: ImmersionGQL.getGavatarImage,
      fetchPolicy: "no-cache",
      variables: {...request}
    }).then((res: any) => {
      if (res.data.getGavatarImage && res.data.getGavatarImage.status === 'true') {
        dispatch(successGetGavatarImage(res.data.getGavatarImage.data.image));
      } else {
        dispatch(successGetGavatarImage(''));
      }
    }).catch(() => {
      dispatch(successGetGavatarImage(''));
    })
  }
};